<template>
  <layout name="LayoutDefault">
    <div class="About">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row ">
            <div class="col-lg-12 ">
              <div class="col-lg-2 ml-auto p-0">
                <select class="form-control" v-model="filterBy" v-on:change="change">
                  <option value="">Select Sort</option>
                  <option value="newest" :selected="filterBy === 'newest'">Newest First</option>
                  <option value="oldest" :selected="filterBy === 'oldest'">Oldest First</option>
                  <option value="az" :selected="filterBy === 'az'">A-Z</option>
                  <option value="za" :selected="filterBy === 'za'">Z-A</option>
                </select>
              </div>

              <div class="section-items ">
                <div v-if="loader">
                  <img slot="preloader" v-bind:src="`${baseUrl}/assets/img/loader.gif`" title="Loading..." />
                </div>
                <div class="row">
                  <div v-for="(item, k) in items" :key="k" class="col-lg-2 col-sm-6 col-6">
                    <ProductCard :item="item" />
                  </div>
                </div>
              </div>

              <nav class="d-flex justify-content-center">
                <ul class="pagination">
                  <li v-for="(item, k) in links" :key="k" :class="getPagingClass(item)">
                    <a class="page-link" @click="getProducts(item.url)" href="javascript:;" v-html="getPagingLabel(item)"></a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import Pagination from "vue-and-pagination";
import ProductCard from './common/ProductCard.vue';

export default {
  name: `Category`,
  data() {
    return {
      loader: true,
      links: null,
      filterBy: this.$route.query.sort ? this.$route.query.sort : '',
      breadType: "",
      items: "",
      orderBy: "",
    };
  },
  components: {
    Layout,
    ProductCard,
    Pagination
  },
  methods: {
    change() {
      let url = this.$helper.UrlGenerate('sort', this.filterBy);
      window.location.href = url;
    },
    getPagingLabel(item) {
      let string = item.label;
      string = string.replace("Next", "");
      string = string.replace("Previous", "");
      return string;
    },
    getPagingClass(item) {
      if (item.url && item.active === true) {
        return "page-item active";
      } else if (!item.url) {
        return "page-item disabled";
      } else {
        return "page-item";
      }
    },
    getProducts(url, sortBy) {
      fetch(url)
        .then(response => response.json())
        .then(json => {
          this.items = json.data;
          this.loader = false;
          //console.log(json);
          this.links = json.links;
          $(".back-to-top").trigger("click");
        });
    }
  },
  mounted() {
    let url = this.APIURL + "products-resources/offer/" + this.$route.params.offerType + '?sort=' + this.filterBy;
    this.getProducts(url, this.filterBy);
  }
};
</script>
